import { Popper } from '@mui/material';

const WidePopper = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Popper {...props} style={{ maxWidth: 'fit-content' }} />
);

export default WidePopper;
